package com.mshopsas.enterprise.aiw.scan.network.request

import kotlinx.serialization.Serializable

@Serializable
data class ConfirmPaymentRequest(
    val basketEncodedId: String
)